import { Shimmer } from '@wartek-id/shimmer'

import type { FC } from 'react'

interface ListItemLoaderProps {
  count?: number
}

const ListItemLoader: FC<ListItemLoaderProps> = ({ count = 1 }) => {
  return (
    <>
      {[...Array(count)].map((i, index) => (
        <div key={index} className="p-4 bg-white">
          <div className="flex flex-row justify-between items-start space-x-3">
            <div className="flex flex-col space-y-1 w-full">
              <Shimmer height={24} noOfLines={1} width="100%" />
              <Shimmer height={88} noOfLines={1} width="100%" />
              <Shimmer
                height={14}
                noOfLines={1}
                width="100%"
                className="!mt-2"
              />
            </div>

            <div className="relative min-w-[80px]">
              <Shimmer height={80} noOfLines={1} width="80" />
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

export default ListItemLoader
